/* eslint-disable max-len */
const PropTypes = require('prop-types');
const React = require('react');

/**
 * GoogleAnalytics renders the Google Analytics script using the given props
 *
 * @param {Object} props component props
 * @returns {Object} React component
 */
function GoogleAnalytics(props) {
  const { cookieDomain, trackingId, isActive, doAutoPageView } = props;
  if (!isActive) {
    return null;
  }

  const pageViewCall = doAutoPageView ? 'ga("send", "pageview");' : '';

  const script = `
  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
          (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

  ga('create', '${trackingId}', '${cookieDomain}');
  ga('require', 'linkid', 'linkid.js');
  ga('require', 'displayfeatures');
  ${pageViewCall}
  `;

  // eslint-disable-next-line react/no-danger
  return <script dangerouslySetInnerHTML={{ __html: script }} />;
}

GoogleAnalytics.propTypes = {
  /**
   * tracking cookie domain
   */
  cookieDomain: PropTypes.string,
  /**
   * flag indicating if page view should be triggered automatically
   */
  doAutoPageView: PropTypes.bool,
  /**
   * flag indicating if analytics should be active
   */
  isActive: PropTypes.bool.isRequired,
  /**
   * GoogleAnalytics Tracking ID
   */
  trackingId: PropTypes.string.isRequired,
};

GoogleAnalytics.defaultProps = {
  cookieDomain: 'soul-cycle.com',
  doAutoPageView: true,
};

module.exports.default = GoogleAnalytics;
